<div class="detail-container">
    <img [src]="this.image"/>
    <p class="detail-font">{{this.content}}</p>
</div>